// extracted by mini-css-extract-plugin
export default {"card":"DetailsCard_card__ep8Qc"};